<template>
  <div class="permission">
    <div class="img"><img class="png" :src="permissionImage" /></div>
    <div class="text-center">您暂无权限访问，请先联系系统管理员处理！</div>
    <div class="text-bottom">-管理员解决完毕后，需要您重新登录门户-</div>
  </div>
</template>

<script>
export default {
  name: 'permission',
  data() {
    return {
      permissionImage: require('@/assets/images/permission.png'),
      showInfo: false
    }
  }
}
</script>
<style scoped>
.permission {
  padding-top: 140px;
}
.img {
  width: 318px;
  height: 274px;
  margin: 0 auto;
}
.png {
  width: 100%;
  height: 100%;
}
.text-center {
  text-align: center;
  font-weight: 500;
  font-size: 38px;
  color: #333333;
  margin-top: 80px;
  margin-bottom: 30px;
}
.text-bottom {
  text-align: center;
  font-size: 32px;
  color: #666666;
}
</style>
